import React, { useEffect, useState } from 'react';
import './materials.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BsArrowLeft } from 'react-icons/bs';
import { config } from "../../config";
import Footer from '../Footer/Footer';
import Lightbox from './Lightbox';
import { useLocalized } from '../../i18n/useLocalized';

const GalleryPage = () => {
    const { t } = useTranslation();
    const loc = useLocalized();
    const navigate = useNavigate();
    const [galleryData, setGalleryData] = useState(
        JSON.parse(localStorage.getItem('galleryData')) || []
    );
    const [lightboxIndex, setLightboxIndex] = useState(null);

    // Always start at the top of the page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchGalleryData = async () => {
            try {
                const response = await fetch(`${config.baseUrl}/galeries`);
                const data = await response.json();

                // Always sync state; only rewrite localStorage when data changed
                setGalleryData(data);
                const storedData = JSON.parse(localStorage.getItem('galleryData')) || [];
                if (JSON.stringify(data) !== JSON.stringify(storedData)) {
                    localStorage.setItem('galleryData', JSON.stringify(data));
                }
            } catch (error) {
                console.error('Error fetching gallery data:', error);
            }
        };

        fetchGalleryData();
    }, []);

    const count = galleryData.length;

    return (
        <>
            <main className="galleryPage container">
                <button
                    className="backLink"
                    onClick={() => navigate('/', { state: { scrollTo: 'gallery' } })}
                >
                    <BsArrowLeft/> {t('gallery.backHome')}
                </button>

                <div className="galleryPageHead">
                    <h1 className="sketchUnderline">{t('gallery.title')}</h1>
                    <p>{t('gallery.subtitle')}</p>
                </div>

                {count > 0 ? (
                    /* Masonry: each image keeps its natural width/height ratio */
                    <div className="galleryMasonry">
                        {galleryData.map((item, i) => (
                            <figure
                                className="masonryItem"
                                key={item.id}
                                onClick={() => setLightboxIndex(i)}
                            >
                                <img src={item.image} alt={loc(item, 'title')} loading="lazy"/>
                                <figcaption className="photoChip">{loc(item, 'title')}</figcaption>
                            </figure>
                        ))}
                    </div>
                ) : (
                    <div className="galleryEmpty">{t('gallery.loading')}</div>
                )}
            </main>

            {lightboxIndex !== null && (
                <Lightbox
                    items={galleryData}
                    index={lightboxIndex}
                    onClose={() => setLightboxIndex(null)}
                    onNavigate={(dir) =>
                        setLightboxIndex((i) => (i + dir + count) % count)
                    }
                />
            )}

            <div id="contact">
                <Footer/>
            </div>
        </>
    );
};

export default GalleryPage;
